<div class="Error">
  <div class="row" *ngIf="!is403()">
    <div class="col-md-4 col-md-4--404"></div>
    <div class="col-md-8">
      <h3>It looks like this page is missing</h3>
      <p>Please verify if the URL is correct or use the filter.</p>
      <p>Still can't find what your looking for?</p>
      <div class="Buttons">
        <p>You can go</p>
        <a href="javascript:void(0)" (click)="goBack()" class="Button Button--blue Button--back">Back</a>
        <p class="Or">or go</p>
        <a [routerLink]="['/']" class="Button Button--blue Button--home">Home</a>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="is403()">
    <div class="col-md-4 col-md-4--403"></div>
    <div class="col-md-8">
      <h3>Access denied</h3>
      <p>You need to upgrade your subscription to access this content.</p>
      <p>Interested ?</p>
      <div class="Buttons">
        <a class="Button Button--blue Button--contact" href="mailto:Discover@cullen-international.com?subject=Spectrum Application interest">Contact us</a>
        <p class="Or">or go</p>
        <a [routerLink]="['/']" class="Button Button--blue Button--home">Home</a>
      </div>
    </div>
  </div>
</div>
